module.exports = __webpack_public_path__ + "img/top-up.1390ed2a.png";